import { useTranslation } from 'react-i18next';
import cls from 'clsx';
import { Dialog, Button } from '@linktivity/link-ui';
import { ConfirmProps } from './Confirm.types';
import styles from './confirm.module.css';

const Confirm = ({
  visible,
  onClose,
  onConfirm,
  title,
  content,
  confirmText: confirmTextProp,
  cancelText: cancelTextProp,
  confirmLoading = false,
  danger = false,
  className = '',
  showCancelButton = true,
  showConfirmButton = true
}: ConfirmProps) => {
  const { t } = useTranslation();
  const confirmText = confirmTextProp ?? t('share.common.confirm');
  const cancelText = cancelTextProp ?? t('share.common.cancel');
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Dialog visible={visible} onClose={onClose} title={title}>
      <div className={cls(styles.confirm, className)}>
        {content && (
          <div className={styles.body}>
            <div className={styles.content}>{content}</div>
          </div>
        )}

        <div className={styles.footer}>
          {showCancelButton && (
            <Button
              className={styles.button}
              variant="text-secondary"
              onClick={onClose}
              disabled={confirmLoading}
            >
              {cancelText}
            </Button>
          )}
          {showConfirmButton && (
            <Button
              className={styles.button}
              variant={danger ? 'text-danger' : 'text'}
              onClick={handleConfirm}
              loading={confirmLoading}
            >
              {confirmText}
            </Button>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default Confirm;
